export default () => ({
  wrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 2,
    mt: 2
  }
});
